import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { recipeIngredientsStore } from '@/store/RecipeIngredientsStore';
import useRightPath from '~/composables/useRightPath';
import usePreventHandlingEmptyLink from '~/composables/usePreventHandlingEmptyLink';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'IngredientsList',
  components: {
    AzImg: AzImg
  },
  props: {
    activeTab: {
      type: String
    },
    allIngredients: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(_props) {
    var store = recipeIngredientsStore;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var findQuantity = function findQuantity(currentIngredient) {
      if (currentIngredient.quantities) {
        return store.findQuantity(currentIngredient.quantities);
      } else {
        return [currentIngredient.quantity];
      }
    };
    var getIngredientName = function getIngredientName(ingredient) {
      var _ingredient$nonPurcha, _ingredient$nonPurcha2;
      if (ingredient.name) {
        return ingredient.name;
      }
      var title = ingredient === null || ingredient === void 0 ? void 0 : (_ingredient$nonPurcha = ingredient.nonPurchasableIngredient) === null || _ingredient$nonPurcha === void 0 ? void 0 : (_ingredient$nonPurcha2 = _ingredient$nonPurcha.fields) === null || _ingredient$nonPurcha2 === void 0 ? void 0 : _ingredient$nonPurcha2.title;
      return title || '';
    };
    var addPlusIfSecondAndAfter = function addPlusIfSecondAndAfter(str, index) {
      if (!str) return '';
      var stringWithoutPlus = str.replace(/\+/g, '');
      if (!index) return stringWithoutPlus;
      return "+ ".concat(stringWithoutPlus);
    };
    var getIngredientImage = function getIngredientImage(ingredient) {
      var _ingredient$nonPurcha3, _ingredient$nonPurcha4, _ingredient$nonPurcha5, _ingredient$nonPurcha6, _ingredient$nonPurcha7;
      if (ingredient.image) {
        return ingredient.image;
      }
      var url = (_ingredient$nonPurcha3 = ingredient.nonPurchasableIngredient) === null || _ingredient$nonPurcha3 === void 0 ? void 0 : (_ingredient$nonPurcha4 = _ingredient$nonPurcha3.fields) === null || _ingredient$nonPurcha4 === void 0 ? void 0 : (_ingredient$nonPurcha5 = _ingredient$nonPurcha4.image) === null || _ingredient$nonPurcha5 === void 0 ? void 0 : (_ingredient$nonPurcha6 = _ingredient$nonPurcha5.fields) === null || _ingredient$nonPurcha6 === void 0 ? void 0 : (_ingredient$nonPurcha7 = _ingredient$nonPurcha6.file) === null || _ingredient$nonPurcha7 === void 0 ? void 0 : _ingredient$nonPurcha7.url;
      return url;
    };
    var getLink = function getLink(ingredient) {
      var slug = ingredient.slug,
        isEssentialOil = ingredient.isEssentialOil;
      return slug ? getProductPath({
        slug: slug,
        isEssentialOil: isEssentialOil
      }) : '';
    };
    return {
      getLink: getLink,
      getIngredientName: getIngredientName,
      getIngredientImage: getIngredientImage,
      findQuantity: findQuantity,
      addPlusIfSecondAndAfter: addPlusIfSecondAndAfter,
      usePreventHandlingEmptyLink: usePreventHandlingEmptyLink
    };
  }
});